import { render, staticRenderFns } from "./qaDetail.vue?vue&type=template&id=bb617200&scoped=true&"
import script from "./qaDetail.vue?vue&type=script&lang=js&"
export * from "./qaDetail.vue?vue&type=script&lang=js&"
import style0 from "./qaDetail.vue?vue&type=style&index=0&id=bb617200&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb617200",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb617200')) {
      api.createRecord('bb617200', component.options)
    } else {
      api.reload('bb617200', component.options)
    }
    module.hot.accept("./qaDetail.vue?vue&type=template&id=bb617200&scoped=true&", function () {
      api.rerender('bb617200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/xiazeng/qaDetail.vue"
export default component.exports